import * as React from 'react'
import * as AppStore from './../state/app-store'
import { useQuery, gql } from '@apollo/client'

import * as Actions from './../state/actions'
import * as Selectors from './../state/selectors'
import * as ClientAuthUtil from '../lib/client-auth'
import * as Types from '../declarations'

// todo: get pseudo user (also rename serverside type to pseudo user)
const tokenCheckQuery = gql`
	query authCheck($token: String!) {
		authCheck(token: $token) {
			isValid
			user {
				id
				role
			}
		}
	}
`

const CheckToken: React.FunctionComponent = () => {
	const dispatch = AppStore.useAppDispatch()
	const token = ClientAuthUtil.getToken()

	const userAuthStatusIsKnown = AppStore.useAppSelector(
		Selectors.userAuthStatusIsKnown,
	)
	const authedUser = AppStore.useAppSelector(Selectors.authedUser)

	// useQuery is always called, but we tell it to skip when there is no token
	const { data } = useQuery(tokenCheckQuery, {
		skip: !token,
		variables: { token },
	})

	React.useEffect(() => {
		if (!token && !userAuthStatusIsKnown) {
			dispatch(Actions.verifiedAuthStatus(false, undefined))
		} else if (data) {
			const {
				isValid: tokenWasValid,
				user,
			}: Types.API.Response.VerifyToken = data?.authCheck
			if (tokenWasValid && !!user) {
				dispatch(Actions.verifiedAuthStatus(tokenWasValid, user))
			} else if (!tokenWasValid && !authedUser) {
				// Only downgrade to guest when nobody is authed: a negative
				// verdict can come from a query fired BEFORE a successful login
				// (against the old/absent cookie) and must not wipe the fresh
				// login that the LOGIN_SUCCEEDED action just established.
				dispatch(Actions.verifiedAuthStatus(false, user))
			}
		} else {
			if (!token) {
				// log them out
				dispatch(Actions.logout())
			}
		}
	}, [token, userAuthStatusIsKnown, data, dispatch, authedUser])

	return null
}

export default CheckToken
